export const ERRORS = {
  SIGN_TRANSACTION: "Transaction signing initiation encountered an error",
  RETRIEVE_PASS_KEYS: "An error occurred while retrieving the passkeys",
  RECAPTCHA: "ReCaptcha failed",
  SCA_INITIALIZATION: "An error occurred during SCA initialization",
  SCA_CREATION: "An error occurred during SCA creation",
  SCA_FINALIZATION: "An error occurred during SCA finalization",
  TOKEN_MISSING: "An error occurred during authentication, token missing",
};
